var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _text, _path103, _text2, _path104, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 750 289"
    },
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .st1{fill:gray}.st2{fill:#ccc}.st3{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}.st4{fill:#404040}.st5{fill:#369;fill-opacity:.502}.st6{fill:#fff}.st7{font-family:&apos;ArialMT&apos;}.st8{font-size:11.4815px}\n  ")), /*#__PURE__*/React.createElement("path", {
    d: "M750 0H0v289.4h750V0z",
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M562.6 155.6l-47.8 24.2.1 22 31.3 2.8c7.2-4.3 12.1-8.1 14.8-11.4 5.7-3.7 17.8-13 36.4-27.8 18.6-14.9 30.7-24.2 36.4-27.9-15.3-.6-69.1-2.5-161.3-5.7-92.2-3.3-146-5.2-161.3-5.8l-25.5 6.3-95.6 48.4 33.4 1.2 25.5-6.3c5.4-2.7 15.5-7.9 30.5-15.4 15-7.6 24.3-12.3 27.9-14.1l54.7 2-64.6 40.5 35.9 1.2c8-4 15.9-8 23.9-12 19.5-10.7 38.2-21 56-30.9 21.2-4.4 37.8-2.8 49.9 4.9l-.8-.1-55.5 42.6 33 1.7c8.3-4.1 12.5-7.1 12.6-9.1 5.2-2.9 14.9-8.6 29.1-17.4 14.2-8.7 23-14.1 26.5-16.1l54.5 2.2z",
    className: "st1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M226 183v-24.1l-35.9-2.5v24.2L226 183z",
    className: "st2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_2_1_STROKES",
    d: "M226 183l-35.9-2.4v-24.2l35.9 2.5V183z",
    className: "st3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M226 158.9v24.2c4.3-4.3 8.7-8.5 13.1-12.6v-24.2c-4.4 4.2-8.7 8.4-13.1 12.6z",
    className: "st4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_3_1_STROKES",
    d: "M226 158.9c4.3-4.2 8.7-8.4 13.1-12.6v24.2c-4.4 4.2-8.8 8.4-13.1 12.6v-24.2z",
    className: "st3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M333.7 190.5v-24.1l-35.9-2.5v24.2l35.9 2.4z",
    className: "st2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_4_1_STROKES",
    d: "M333.7 190.6l-35.9-2.4V164l35.9 2.5v24.1z",
    className: "st3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M333.7 166.4v24.2c4.3-4.3 8.7-8.5 13.1-12.6v-24.2c-4.4 4.2-8.7 8.4-13.1 12.6z",
    className: "st4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_5_1_STROKES",
    d: "M333.7 166.4c4.3-4.2 8.7-8.4 13.1-12.6V178c-4.4 4.2-8.8 8.4-13.1 12.6v-24.2z",
    className: "st3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M315.6 141l-17.8-1.2V164l17.8 1.2V141z",
    className: "st2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_6_1_STROKES",
    d: "M315.7 141v24.1l-17.8-1.2v-24.2l17.8 1.3z",
    className: "st3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M333.7 142.2l-18-1.2v24.2l18 1.2v-24.2z",
    className: "st2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_7_1_STROKES",
    d: "M333.7 142.3v24.2l-18-1.2V141l18 1.3z",
    className: "st3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M333.7 142.1v24.2c4.3-4.3 8.7-8.5 13.1-12.6v-24.2c-4.4 4.2-8.7 8.4-13.1 12.6z",
    className: "st4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_8_1_STROKES",
    d: "M333.7 142.2c4.3-4.2 8.7-8.4 13.1-12.6v24.2c-4.4 4.2-8.8 8.4-13.1 12.6v-24.2z",
    className: "st3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M441.3 198v-24.1l-35.9-2.5v24.2l35.9 2.4z",
    className: "st2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_9_1_STROKES",
    d: "M441.3 198.1l-35.9-2.4v-24.2l35.9 2.5v24.1z",
    className: "st3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M441.3 173.8V198c4.3-4.3 8.7-8.5 13.1-12.6v-24.2c-4.4 4.2-8.8 8.4-13.1 12.6z",
    className: "st4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_10_1_STROKES",
    d: "M441.3 173.8c4.3-4.2 8.7-8.4 13.1-12.6v24.2c-4.4 4.2-8.8 8.4-13.1 12.6v-24.2z",
    className: "st3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M423.4 148.4l-18-1.2v24.2l18 1.2v-24.2z",
    className: "st2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_11_1_STROKES",
    d: "M423.4 148.4v24.1l-18-1.2v-24.2l18 1.3z",
    className: "st3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M441.3 149.6v24.1c4.3-4.2 8.7-8.4 13.1-12.6V137c-4.4 4.2-8.8 8.4-13.1 12.6z",
    className: "st4"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_12_1_STROKES",
    d: "M441.3 149.7c4.3-4.2 8.7-8.4 13.1-12.6v24.1c-4.4 4.2-8.8 8.4-13.1 12.6v-24.1z",
    className: "st3"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M441.3 173.8v-24.1l-18-1.2v24.2l18 1.1z",
    className: "st2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_13_1_STROKES",
    d: "M441.3 173.8l-18-1.2v-24.2l18 1.2v24.2z",
    className: "st3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M548.7 205.5v-24.1l-35.7-2.5v24.2l35.7 2.4z",
    className: "st2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_14_1_STROKES",
    d: "M548.8 205.6l-35.7-2.4V179l35.7 2.5v24.1z",
    className: "st3"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M548.7 181.3v24.2c4.3-4.3 8.7-8.5 13.1-12.6v-24.2c-4.4 4.2-8.8 8.4-13.1 12.6z",
    className: "st4"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_15_1_STROKES",
    d: "M548.7 181.3c4.3-4.2 8.7-8.4 13.1-12.6v24.2c-4.4 4.2-8.8 8.4-13.1 12.6v-24.2z",
    className: "st3"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M208.1 157.6v-24.1l-18-1.2v24.2l18 1.1z",
    className: "st2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_16_1_STROKES",
    d: "M208.1 157.7l-18-1.2v-24.2l18 1.2v24.2z",
    className: "st3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M226 134.6v24.1c4.3-4.2 8.7-8.4 13.1-12.6V122c-4.4 4.2-8.7 8.4-13.1 12.6z",
    className: "st4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_17_1_STROKES",
    d: "M226 134.7c4.3-4.2 8.7-8.4 13.1-12.6v24.1c-4.4 4.2-8.8 8.4-13.1 12.6v-24.1z",
    className: "st3"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M226 158.9v-24.1l-18-1.2v24.2l18 1.1z",
    className: "st2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_18_1_STROKES",
    d: "M226 158.9l-18-1.2v-24.2l18 1.2v24.2z",
    className: "st3"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M226 134.7v-24.1l-35.9-2.5v24.2l35.9 2.4z",
    className: "st2"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_19_1_STROKES",
    d: "M226 134.7l-35.9-2.4v-24.2l35.9 2.5v24.1z",
    className: "st3"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M226 110.5v24.2c4.3-4.3 8.7-8.5 13.1-12.6V97.9c-4.4 4.2-8.7 8.4-13.1 12.6z",
    className: "st4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_20_1_STROKES",
    d: "M226 110.5c4.3-4.2 8.7-8.4 13.1-12.6v24.2c-4.4 4.2-8.8 8.4-13.1 12.6v-24.2z",
    className: "st3"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M208.1 109.3V85.2l-18-1.2v24.2l18 1.1z",
    className: "st2"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_21_1_STROKES",
    d: "M208.1 109.3l-18-1.2V83.9l18 1.2v24.2z",
    className: "st3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M190.1 83.9l18 1.2c4.3-4.2 8.7-8.4 13-12.6-6-.4-11.9-.9-17.9-1.2-4.4 4.2-8.7 8.4-13.1 12.6z",
    className: "st1"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_22_1_STROKES",
    d: "M190.1 83.9c4.3-4.2 8.7-8.4 13.1-12.6 6 .4 11.9.8 17.9 1.2-4.3 4.2-8.7 8.4-13 12.6l-18-1.2z",
    className: "st3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M243.9 111.7l6.9-23.7-42.8-3v24.2l35.9 2.5z",
    className: "st2"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_23_1_STROKES",
    d: "M243.9 111.7l-35.9-2.4V85.1l42.8 3-6.9 23.6z",
    className: "st3"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M208 85.1c14.3 1 28.5 2 42.8 3 4.4-4.2 8.8-8.4 13.1-12.6-14.3-1-28.5-2-42.8-3-4.4 4.2-8.7 8.4-13.1 12.6z",
    className: "st1"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_24_1_STROKES",
    d: "M208.1 85.1c4.3-4.2 8.7-8.4 13.1-12.6 14.3 1 28.5 2 42.8 3-4.3 4.2-8.7 8.4-13.1 12.6-14.3-1-28.6-2-42.8-3z",
    className: "st3"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M250.9 88.1c7.4.5 14.7 1 22 1.5 4.3-4.2 8.7-8.4 13.1-12.6-7.4-.5-14.7-1-22-1.5-4.4 4.2-8.8 8.4-13.1 12.6z",
    className: "st1"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_25_1_STROKES",
    d: "M250.9 88.1c4.3-4.2 8.7-8.4 13.1-12.6 7.3.5 14.7 1 22 1.5-4.4 4.2-8.8 8.4-13.1 12.6-7.3-.5-14.7-1-22-1.5z",
    className: "st3"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M279.8 114.2l-6.9-24.7-22-1.5-6.9 23.7 35.8 2.5z",
    className: "st2"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_26_1_STROKES",
    d: "M279.8 114.3l-35.9-2.5 6.9-23.7 22 1.5 7 24.7z",
    className: "st3"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M333.7 118v24.2c4.3-4.3 8.7-8.5 13.1-12.6v-24.2c-4.4 4.2-8.7 8.4-13.1 12.6z",
    className: "st4"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_27_1_STROKES",
    d: "M333.7 118c4.3-4.2 8.7-8.4 13.1-12.6v24.2c-4.4 4.2-8.8 8.4-13.1 12.6V118z",
    className: "st3"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M333.7 142.2v-24.1l-35.9-2.5v24.2l35.9 2.4z",
    className: "st2"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_28_1_STROKES",
    d: "M333.7 142.2l-35.9-2.4v-24.2l35.9 2.5v24.1z",
    className: "st3"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M272.9 89.6c14.3 1 28.5 2 42.8 3 4.4-4.2 8.8-8.4 13.1-12.6-14.3-1-28.5-2-42.8-3-4.4 4.2-8.7 8.4-13.1 12.6z",
    className: "st1"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_29_1_STROKES",
    d: "M272.9 89.7c4.3-4.2 8.7-8.4 13.1-12.6 14.3 1 28.5 2 42.8 3-4.3 4.2-8.7 8.4-13.1 12.6-14.3-1.1-28.5-2-42.8-3z",
    className: "st3"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M315.7 116.8V92.6l-42.8-3 6.9 24.7 35.9 2.5z",
    className: "st2"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_30_1_STROKES",
    d: "M315.7 116.8l-35.9-2.5-6.9-24.7 42.8 3v24.2z",
    className: "st3"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M315.7 92.6c12 .8 23.9 1.7 35.9 2.5 4.4-4.2 8.8-8.4 13.1-12.6-12-.8-23.9-1.7-35.9-2.5-4.4 4.2-8.8 8.4-13.1 12.6z",
    className: "st1"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_31_1_STROKES",
    d: "M315.7 92.6c4.3-4.2 8.7-8.4 13.1-12.6 11.9.8 23.9 1.7 35.9 2.5-4.3 4.2-8.7 8.4-13.1 12.6-12-.8-23.9-1.6-35.9-2.5z",
    className: "st3"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M351.5 95.1l-35.9-2.5v24.2l17 1.2c5.9-2.6 12.2-4.5 18.8-5.5 1.9-.3 3.9-.5 5.9-.7l-5.8-16.7z",
    className: "st2"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_32_1_STROKES",
    d: "M351.6 95.1l5.9 16.7c-2 .1-3.9.4-5.9.7-6.6 1.1-12.9 2.9-18.8 5.5l-17-1.2V92.6l35.8 2.5z",
    className: "st3"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M351.6 95.1l5.9 16.7c3.9-.3 8-.3 12.1-.1 4.1.3 8.1.9 12.1 1.7l5.8-15.9-35.9-2.4z",
    className: "st2"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_33_1_STROKES",
    d: "M351.6 95.1l35.9 2.5-5.8 15.9c-4-.8-8-1.4-12.1-1.7-4.1-.3-8.2-.2-12.1.1l-5.9-16.8z",
    className: "st3"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M351.6 95.1c12 .8 23.9 1.7 35.9 2.5 4.4-4.2 8.8-8.4 13.1-12.6-12-.8-23.9-1.7-35.9-2.5-4.4 4.2-8.8 8.4-13.1 12.6z",
    className: "st1"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_34_1_STROKES",
    d: "M351.6 95.1c4.3-4.2 8.7-8.4 13.1-12.6 11.9.8 23.9 1.7 35.9 2.5-4.3 4.2-8.7 8.4-13.1 12.6-12-.8-23.9-1.6-35.9-2.5z",
    className: "st3"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M441.3 149.6v-24.1l-35.9-2.5v24.2l35.9 2.4z",
    className: "st2"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_35_1_STROKES",
    d: "M441.3 149.6l-35.9-2.4V123l35.9 2.5v24.1z",
    className: "st3"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M441.3 125.5v24.2c4.3-4.3 8.7-8.5 13.1-12.6v-24.2c-4.4 4.2-8.8 8.4-13.1 12.6z",
    className: "st4"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_36_1_STROKES",
    d: "M441.3 125.5c4.3-4.2 8.7-8.4 13.1-12.6v24.2c-4.4 4.2-8.8 8.4-13.1 12.6v-24.2z",
    className: "st3"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M387.5 97.6c12 .8 23.9 1.7 35.9 2.5 4.4-4.2 8.8-8.4 13.1-12.6-12-.8-23.9-1.7-35.9-2.5-4.4 4.2-8.8 8.4-13.1 12.6z",
    className: "st1"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_37_1_STROKES",
    d: "M387.5 97.6c4.3-4.2 8.7-8.4 13.1-12.6 11.9.8 23.9 1.7 35.9 2.5-4.3 4.2-8.7 8.4-13.1 12.6-12-.8-23.9-1.6-35.9-2.5z",
    className: "st3"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M387.4 97.6l-5.9 15.9c2 .4 3.9.9 5.9 1.4 6.6 2 12.9 4.7 18.8 8.1l17 1.2v-24.1l-35.8-2.5z",
    className: "st2"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_38_1_STROKES",
    d: "M387.5 97.6l35.9 2.5v24.1l-17-1.2c-5.9-3.4-12.2-6.1-18.8-8.1-1.9-.5-3.9-1-5.9-1.4l5.8-15.9z",
    className: "st3"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M423.3 100c12 .8 23.9 1.7 35.9 2.5 4.4-4.2 8.8-8.4 13.1-12.6-12-.8-23.9-1.7-35.9-2.5-4.4 4.2-8.7 8.4-13.1 12.6z",
    className: "st1"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_39_1_STROKES",
    d: "M423.3 100c4.3-4.2 8.7-8.4 13.1-12.6 11.9.8 23.9 1.7 35.9 2.5-4.3 4.2-8.7 8.4-13.1 12.6-12-.8-23.9-1.7-35.9-2.5z",
    className: "st3"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M459.2 126.7v-24.1l-35.9-2.5v24.2l35.9 2.4z",
    className: "st2"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_40_1_STROKES",
    d: "M459.2 126.7l-35.9-2.4V100l35.9 2.5v24.2z",
    className: "st3"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M531 155.9l-18-1.2v24.2l18 1.2v-24.2z",
    className: "st2"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_41_1_STROKES",
    d: "M531 155.9V180l-18-1.2v-24.2l18 1.3z",
    className: "st3"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M548.7 157.1v24.2c4.3-4.3 8.7-8.5 13.1-12.6v-24.2c-4.4 4.2-8.8 8.4-13.1 12.6z",
    className: "st4"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_42_1_STROKES",
    d: "M548.7 157.2c4.3-4.2 8.7-8.4 13.1-12.6v24.2c-4.4 4.2-8.8 8.4-13.1 12.6v-24.2z",
    className: "st3"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M548.7 181.3v-24.1l-17.8-1.2v24.2l17.8 1.1z",
    className: "st2"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_43_1_STROKES",
    d: "M548.7 181.3l-17.8-1.2v-24.2l17.8 1.2v24.2z",
    className: "st3"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M548.7 157v-24.1l-35.7-2.5v24.2l35.7 2.4z",
    className: "st2"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_44_1_STROKES",
    d: "M548.8 157l-35.7-2.4v-24.2l35.7 2.5V157z",
    className: "st3"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M548.7 132.9v24.2c4.3-4.3 8.7-8.5 13.1-12.6v-24.2c-4.4 4.2-8.8 8.4-13.1 12.6z",
    className: "st4"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_45_1_STROKES",
    d: "M548.7 132.9c4.3-4.2 8.7-8.4 13.1-12.6v24.2c-4.4 4.2-8.8 8.4-13.1 12.6v-24.2z",
    className: "st3"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M495.1 129.2V105l-35.9-2.5v24.2l35.9 2.5z",
    className: "st2"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_46_1_STROKES",
    d: "M495.1 129.2l-35.9-2.4v-24.2l35.9 2.5v24.1z",
    className: "st3"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M459.2 102.5c12 .8 23.9 1.7 35.9 2.5 4.4-4.2 8.8-8.4 13.1-12.6-12-.8-23.9-1.7-35.9-2.5-4.4 4.2-8.7 8.4-13.1 12.6z",
    className: "st1"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_47_1_STROKES",
    d: "M459.3 102.5c4.3-4.2 8.7-8.4 13.1-12.6 11.9.8 23.9 1.7 35.9 2.5-4.3 4.2-8.7 8.4-13.1 12.6-12-.8-24-1.7-35.9-2.5z",
    className: "st3"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M530.9 131.7v-24.1l-35.9-2.5v24.2l35.9 2.4z",
    className: "st2"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_48_1_STROKES",
    d: "M531 131.7l-35.9-2.4V105l35.9 2.5v24.2z",
    className: "st3"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M495.1 105c12 .8 23.9 1.7 35.9 2.5 4.4-4.2 8.8-8.4 13.1-12.6-12-.8-23.9-1.7-35.9-2.5-4.4 4.2-8.8 8.4-13.1 12.6z",
    className: "st1"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_49_1_STROKES",
    d: "M495.1 105c4.3-4.2 8.7-8.4 13.1-12.6 11.9.8 23.9 1.7 35.9 2.5-4.3 4.2-8.7 8.4-13.1 12.6-12-.8-23.9-1.7-35.9-2.5z",
    className: "st3"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M548.7 132.9v-24.1l-17.8-1.2v24.2l17.8 1.1z",
    className: "st2"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_50_1_STROKES",
    d: "M548.7 132.9l-17.8-1.2v-24.2l17.8 1.2v24.2z",
    className: "st3"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M530.9 107.5c5.9.4 11.8.8 17.8 1.2 4.3-4.2 8.7-8.4 13.1-12.6-5.9-.4-11.8-.9-17.8-1.2-4.4 4.2-8.8 8.4-13.1 12.6z",
    className: "st1"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_51_1_STROKES",
    d: "M531 107.5c4.3-4.2 8.7-8.4 13.1-12.6 5.9.4 11.8.8 17.8 1.2-4.4 4.2-8.8 8.4-13.1 12.6-6-.4-11.9-.8-17.8-1.2z",
    className: "st3"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M548.7 108.7v24.2c4.3-4.3 8.7-8.5 13.1-12.6V96.1c-4.4 4.2-8.8 8.4-13.1 12.6z",
    className: "st4"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "item8_0_Layer0_52_1_STROKES",
    d: "M548.7 108.7c4.3-4.2 8.7-8.4 13.1-12.6v24.2c-4.4 4.2-8.8 8.4-13.1 12.6v-24.2z",
    className: "st3"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M290.7 162.2c-2.4-2.4-5.2-3.6-8.6-3.6s-6.3 1.2-8.7 3.6c-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7 5.3 3.6 8.7 3.6c3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    className: "st5"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st6 st7 st8",
    transform: "matrix(.9981 0 0 1 278.167 175.7681)"
  }, "\n    1\n  ")), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M398.6 162.2c-2.4-2.4-5.2-3.6-8.6-3.6s-6.3 1.2-8.7 3.6c-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7 5.3 3.6 8.7 3.6c3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7s-1.2-6.3-3.6-8.7z",
    className: "st5"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "st6 st7 st8",
    transform: "matrix(.9981 0 0 1 386.0674 175.7681)"
  }, "\n    2\n  ")), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M505.2 162.2c-2.4-2.4-5.2-3.6-8.6-3.6s-6.3 1.2-8.7 3.6c-2.4 2.4-3.6 5.3-3.6 8.7s1.2 6.3 3.6 8.7 5.3 3.6 8.7 3.6c3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    className: "st5"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "st6 st7 st8",
    transform: "matrix(.9981 0 0 1 492.667 175.7681)"
  }, "\n    3\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem8);
export default __webpack_public_path__ + "static/media/item8.92c580f9d3fe802a91f9d818f2c00849.svg";
export { ForwardRef as ReactComponent };